// extracted by mini-css-extract-plugin
module.exports = {"right-align":"signup_right-align__oGD0L","register-head":"signup_register-head__2bi1w","btn-holo":"signup_btn-holo__13i15","right-footer":"signup_right-footer__2uWpI"};